export const sortByDate = dates => {
  if (dates && dates.length > 0) {
    return dates.sort((a, b) => new Date(a) - new Date(b));
  }

  return [];
};

export default sortByDate;
